import { GetServerSideProps } from 'next';
import { api, mimir, site } from '@/services/api';
import { FeaturedNewsApi, FeaturedNewsType } from '@/pages/[categorias]/p/[p]';
import dynamic from 'next/dynamic';
import { AdContainer } from '@/components/Layout/ItemListLastNews/styles';
import FeaturedLastNews from '@/components/Home/FeaturedLastNews';
import { NavBarContentData, TimeLineApi } from '@/shared/types/home.types';
import getConcurrentPromises from '@/utils/getConcurrentPromises';
import Layout from '@/components/Layout';
import { SchemaType } from '@/components/Internals/InternalSchema';
import { FeaturedTimelineData, HeadTags } from '../[categorias]';

interface WebstoriesProps extends FeaturedNewsType {
  timelineData: FeaturedTimelineData;
  schema?: SchemaType;
}

export default function WebStories({ navBarData, tagsData, segmentacoes, timelineData, schema = null }: WebstoriesProps) {
  const AdsTypeGenerators = dynamic(() => import('@/components/Ads/Google/AdsTypeGenerators'), { ssr: false });

  return (
    <Layout layoutData={{ navBarData, tagsData, segmentacoes, schema }}>
      <FeaturedLastNews
        featuredLastNewsData={timelineData.timeline}
        rootPage="webstories"
        textTitle={timelineData.titulo || 'Últimos Webstories'}
        headingTag="h1"
        routeType="tipo"
        route="webstories"
      />
    </Layout>
  );
}
export const getServerSideProps: GetServerSideProps = async context => {
  const { host } = context.req.headers;

  const mainReq = { promise: site.get<FeaturedNewsApi>(`/webstories/`), link: `/webstories/` };
  const timelineReq = { promise: mimir.get<TimeLineApi>(`/timelines/ultimas/tipo/webstories`), link: `/timelines/ultimas/tipo/webstories` };
  const responseMenuReq = { promise: api.get<NavBarContentData>(`/componentes/menu/`), link: `/componentes/menu/` };

  const { promiseData, data, statusCode } = await getConcurrentPromises({
    mainPromise: mainReq,
    navBarPromise: responseMenuReq,
    timelinePromise: timelineReq,
    host,
  });

  if (data.redirect || data.notFound) return data;

  const homeData = data;
  const navBarData: NavBarContentData = promiseData[responseMenuReq.link].data.data;
  const tagsData = data.ssr;
  const { segmentacoes, schema, headers } = data;
  const timelineData = promiseData[timelineReq.link].data.data;

  context.res.setHeader('Cache-Control', headers['Cache-control']);
  context.res.setHeader('Expires', headers.Expires);
  context.res.statusCode = statusCode;

  return {
    props: {
      tagsData,
      homeData,
      navBarData,
      segmentacoes,
      timelineData,
      schema,
    },
  };
};
